import { wave } from './config';
import { Shop } from '@/store/shop';

export async function getSuggestionsV31(query, collectionTypes = ['Common']) {
  const shopId = Shop?.getValue()?.selectedShop?._id;

  try {
    const response = await wave.get('/v3.1/products/search/suggestions', {
      params: {
        collectionTypes,
        term: query,
        // ...(shopId && { shop: shopId }),
      },
    });
    return response.data;
  } catch (error) {
    return { error };
  }
}

export async function getSearchResultsV31(resource) {
  const shopId = Shop?.getValue()?.selectedShop?._id;

  try {
    const response = await wave.get('/v3.1/products/search', {
      params: {
        pageNumber: '0',
        ...(shopId && { shop: shopId }),
        ...resource,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}
